export enum FamilyMemberDisplayMode {
    ShowFamilyMembers = 0,
    HideFamilyMembers = 1
}
